const NOT_FOUND_INDEX = -1

export function getListWithRestoredItem<T>(
  initialValues: readonly T[],
  currentValues: readonly T[],
  itemToRestore: Readonly<T>,
  isSameRow: (itemA: Readonly<T>, itemB: Readonly<T>) => boolean
): T[] {
  const indexInitialValue = initialValues.findIndex((item) => isSameRow(item, itemToRestore))

  if (indexInitialValue === NOT_FOUND_INDEX) throw new Error('Item to restore not found in initial values')

  const indexCurrentValue = currentValues.findIndex((item) => isSameRow(item, itemToRestore))

  const initialValue = initialValues[indexInitialValue]
  const updatedCurrentValues = [...currentValues]

  if (indexCurrentValue > NOT_FOUND_INDEX) {
    updatedCurrentValues[indexCurrentValue] = initialValue
  } else {
    updatedCurrentValues.splice(indexInitialValue, 0, initialValue)
  }

  return updatedCurrentValues
}
